import { RegisterCompanyContract } from 'models'
import {
    INewAccountContract,
    IRestaurantInfo,
    IRestaurantLocation,
    IRestaurantSetup,
} from '../CreateCompanyContext'

export type TBuiltRegisterContract = {
    account: INewAccountContract
    restaurantInfo: IRestaurantInfo
    restaurantLocation: IRestaurantLocation
    restaurantSetup: IRestaurantSetup
    timezoneName: string
}

export const buildMasterAccount = (
    account: INewAccountContract,
): RegisterCompanyContract['masterAccount'] => {
    const { confirmPassword, confirmPin, ...masterAccount } = account
    return masterAccount
}

export const buildCompanyContract = (
    restaurantInfo: IRestaurantInfo,
    props: {
        isTaxInclusive: boolean
        isUseDemoData: boolean
    },
): RegisterCompanyContract['company'] => {
    return {
        name: restaurantInfo.name,
        email: restaurantInfo.email,
        address: restaurantInfo.address,
        isTaxInclusive: props.isTaxInclusive,
        isUseDemoData: props.isUseDemoData,
    }
}

export const buildLocationContract = (
    restaurantLocation: IRestaurantLocation,
): RegisterCompanyContract['location'] => {
    return {
        name: restaurantLocation.name,
        subDomain: restaurantLocation.subDomain,
        address: restaurantLocation.address,
    }
}

const buildRegisterContract = ({
    account,
    timezoneName,
    restaurantInfo,
    restaurantLocation,
    restaurantSetup,
}: TBuiltRegisterContract): RegisterCompanyContract => {
    return {
        masterAccount: buildMasterAccount(account),
        company: buildCompanyContract(restaurantInfo, {
            isTaxInclusive: restaurantSetup.isTaxInclusive,
            isUseDemoData: restaurantSetup.demoData === 'yes',
        }),
        location: buildLocationContract(restaurantLocation),
        locationAddressSameCompany:
            restaurantLocation.locationAddressSameCompany,
        timezoneName,
        subDomain: restaurantLocation.subDomain,
        currencyId: restaurantSetup.currencyId,
        demoData: restaurantSetup.demoData === 'yes',
        recaptchaCode: restaurantSetup.recaptchaCode,
    }
}

export default buildRegisterContract
